import { RunCandidateScore } from 'src/app/public/app/models/runCandidateScore';
import { JobMatchQueryFilter } from 'src/app/public/app/models/jobMatchQueryFilter';
import { FormalizeCandidate, FormalizeCompany, FormalizeRequisition, FormalizeJobMatch } from 'src/app/public/app/models/formalizePayload';
class CandidateJobMatchCardController {
    /*@ngInject*/
    constructor($rootScope, $state, $timeout, $filter, StorageService, jobMatchService, jobMatchActionsService, webSocketsService, alertsAndNotificationsService, resumeService, userRoleService, candidateService, companyService, sharedService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.StorageService = StorageService;
        this.jobMatchService = jobMatchService;
        this.jobMatchActionsService = jobMatchActionsService;
        this.webSocketsService = webSocketsService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.candidateService = candidateService;
        this.resumeService = resumeService;
        this.userRoleService = userRoleService;
        this.companyService = companyService;
        this.sharedService = sharedService;
    }
    $onInit() {
        //variables
        this.notesTooltipIsOpen = false;
        this.candidateJobMatches = [];
        this.candidateCardNotesModal = null;
        this.jobMatchIdModal = null;
        this.candidateMeetingsModal = null;
        this.setStatusModal = null;
        this.candidateAssessmentInfoModal = null;
        this.candidateImageProctoringInfoModal = null;
        this.candidateCardCommunicationModal = null;
        this.candidateCardShowAllActivitiesModal = null;
        this.notificationsSearchObject = {};
        this.userNotificationControls = {};
        this.userNotificationControls.notificationClickCount = 0;
        this.recentActivitiesControls = {};
        this.recentActivitiesControls.activityClickCount = 0;
        this.isActivityClicked = false;
        this.isNotificationClicked = false;
        this.numberOfNewNotifications = 0;
        this.communicationActionObject = null;
        this.peerCommunicationActionObject = null;
        this.notesActionObject = null;
        this.assignRecruiterActionObject = null;
        this.notInterestedActionObject = null;
        this.releaseActionObject = null;
        this.jobMatchScoreTitle = "Job Match Score";
        this.updateContactActionObject = {
            action: "Update Candidate Details",
            actionType: "UPDATE_CONTACT",
            allowed: true,
            message: null
        };
        this.candidateJobCompareActionObject = {
            action: "Candidate Job Comparison",
            actionType: "CANDIDATE_JOB_COMPARE",
            allowed: true,
            message: null,
            candidateDetails: this._setJobMatchCandidateDetails('booklet', this.candidateJobMatch),
        };
        let candidateName = this.candidateJobMatch.firstName + " " + this.candidateJobMatch.lastName;
        this.candidateProfileActionObject = {
            action: candidateName + "'s" + " " + "Booklet",
            actionType: "CANDIDATE_PROFILE",
            allowed: true,
            message: null,
            candidateDetails: this._setJobMatchCandidateDetails('booklet', this.candidateJobMatch),
        };
        this.sendEmailProfileActionObject = {
            action: "Send Email",
            actionType: "SEND_EMAIL",
            allowed: true,
            message: null,
            candidateDetails: this._setJobMatchCandidateDetails('email', this.candidateJobMatch),
        };
        this.reRunScoreActionObject = {
            action: "Run Candidate Score",
            actionType: "RUN_CANDIDATE_SCORE",
            allowed: true,
            message: null,
            displayAction: true
        };
        this.sendPeerEmailProfileActionObject = _.cloneDeep(this.sendEmailProfileActionObject);
        this.sendPeerEmailProfileActionObject.candidateDetails.candidateEmail = null;
        this.uploadResumeActionObject = {
            actionType: "UPLOAD_RESUME",
            action: "Upload Resume",
            message: null,
            allowed: true
        };
        //flags
        this.disabledFlag = false;
        this.dirtyFlag = false;
        this.loadingFlag = true;
        this.loadingMeetingsFlag = true;
        this.refreshingJobMatchStatusFlag = false;
        this.showIntelligenceScoreFlag = false;
        this.intelligenceScorePassFlag = false;
        this.showTechAssessmentScoreFlag = false;
        this.techAssessmentScorePassFlag = false;
        this.showValueAssessmentScoreFlag = false;
        this.showCommunicationFlag = false;
        this.showPeerCommunicationFlag = false;
        this.showNotesFlag = false;
        this.showAssignRecruiterFlag = false;
        this.showNotInterestedFlag = false;
        this.showReleaseFlag = false;
        this.showInterviewCountFlag = false;
        this.showPhoneScreenCountFlag = false;
        this.showAssessmentInfoFlag = false;
        this.isCorporateFlag = false;
        this.disableProfileLink = false;
        // flag used to reload the notifications directive.
        this.showNotificationsFlag = false;
        // flag used to reload the recent activities directive.
        this.showRecentActivitiesFlag = false;
        this.showAdditionalDetailsIconsFlag = false;
        this.showSalary = true;
        this.isVendorOnly = this.companyService.isCompanyVendor();
        ;
        this.init(false);
        this.clientReviewActionObject = {
            action: "Client Review",
            actionType: "CLIENT_REVIEW",
            allowed: true,
            message: null,
            clientReviewDetails: true // need to add client details
        };
    }
    init(isRefresh) {
        this.userId = this.$rootScope.userDetails.id;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporateFlag = (this.$rootScope.userDetails.company.companyType == 'Corporation');
        this.isSuperUser = this.userRoleService.isLoggedInUserSuperUser();
        this.is4dot5UserAdmin = this.userRoleService.isLoggedInUser4dot5Admin();
        this.numberOfNewNotifications = 0;
        this.notificationsSearchObject.page = 1;
        this.notificationsSearchObject.size = 3;
        this.notificationsSearchObject.jobMatchId = this.jobMatchId;
        this.notificationsSearchObject.companyId = this.companyId;
        this.notificationsSearchObject.notifyOn = 'CANDIDATE_JOB_CARD';
        this.userNotificationControls.setNewNotificationsAsViewed = null;
        this.recentActivitiesControls.getActivities = null;
        this.showNotificationsFlag = true;
        this.showRecentActivitiesFlag = true;
        this.showAdditionalDetailsIconsFlag = false;
        if (_.isUndefined(this.activityMap)) {
            this.activityMap = [];
        }
        if (isRefresh) {
            this.candidateJobMatchCopy = Object.assign({}, this.candidateJobMatch);
        }
        // get the candidate card
        if (isRefresh || this.context !== "workflow") {
            this.getCandidateJobMatchCardInfo();
        }
        else {
            this.candidateJobMatch = this._massageCandidateJobMatchData(this.candidateJobMatch);
            this._setActionsOnTheCard();
            this.loadingFlag = false;
        }
        // listen to notification on the card and refresh the card
        if (!isRefresh) {
            this.listenToStateUpdate();
            this.listenToIncomingChatMessage();
        }
    }
    refreshCard() {
        if (!this.loadingFlag) {
            console.log("REFRESHING CARD");
            this._resetAndRefreshCard();
        }
        // else {
        //     this.$timeout(() =>  {
        //          console.log("REFRESHING CARD AFTER 2 SEC TIMEOUT");
        //         this._resetAndRefreshCard();
        //     }, 2000);
        // }
    }
    _resetAndRefreshCard() {
        //re initialize flags
        this.loadingFlag = true;
        this.loadingMeetingsFlag = true;
        this.showIntelligenceScoreFlag = false;
        this.intelligenceScorePassFlag = false;
        this.showTechAssessmentScoreFlag = false;
        this.techAssessmentScorePassFlag = false;
        this.showValueAssessmentScoreFlag = false;
        this.showCommunicationFlag = false;
        this.showPeerCommunicationFlag = false;
        this.showNotesFlag = false;
        this.showAssignRecruiterFlag = false;
        this.showNotInterestedFlag = false;
        this.showReleaseFlag = false;
        this.communicationActionObject = null;
        this.peerCommunicationActionObject = null;
        this.notesActionObject = null;
        this.assignRecruiterActionObject = null;
        this.notInterestedActionObject = null;
        this.releaseActionObject = null;
        this.showInterviewCountFlag = false;
        this.showPhoneScreenCountFlag = false;
        this.showAssessmentInfoFlag = false;
        this.notifications = [];
        this.showNotificationsFlag = false;
        this.showRecentActivitiesFlag = false;
        this.showAdditionalDetailsIconsFlag = false;
        // timeout so that the notifications module can be removed and added back
        this.$timeout(() => {
            // re initialize
            this.init(true);
        }, 300);
    }
    _getJobMatchInfoAndUpdateState() {
        this.refreshingJobMatchStatusFlag = true;
        this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
            this.candidateJobMatch.jobMatchCurrentState = data.jobMatchCurrentState;
            this.candidateJobMatch.jobMatchCurrentStateDisplayLabel = data.jobMatchCurrentState.replace('Cancelled', 'Canceled');
            this.candidateJobMatch.numberOfOpenInterviews = data.numberOfOpenInterviews;
            this.candidateJobMatch.numberOfOpenPhoneScreens = data.numberOfOpenPhoneScreens;
            this.refreshingJobMatchStatusFlag = false;
        }, (error) => {
            this.refreshingJobMatchStatusFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    listenToStateUpdate() {
        this.workFlowUpdateListener = this.$rootScope.$on("REFRESH_JOB_MATCH_CARD", (event, stateChange) => {
            if (stateChange.jobmatchId == this.jobMatchId) {
                if (stateChange.refreshWorkflow) {
                    console.log('Step Change: Marking card as dirty');
                    this.disabledFlag = true;
                    this.dirtyFlag = true;
                }
                else {
                    console.log('State Change: Refreshing job match card');
                    this.refreshCard();
                }
                console.log(stateChange);
            }
        });
    }
    listenToIncomingChatMessage() {
        this.webSocketsService.receiveMessage().then(null, null, (message) => {
            if (message.jobMatchId == this.jobMatchId) {
                this.candidateJobMatch.unreadChatMessageCount++;
            }
        });
    }
    getReport(assessmentType, isSectionalReport, reportUrl) {
        let testInvitationId = this.candidateJobMatch.techAssessmentInvitationId;
        if (assessmentType == 'Value') {
            testInvitationId = this.candidateJobMatch.valueAssessmentInvitationId;
        }
        this.jobMatchActionsService.getReport(this.jobMatchId, assessmentType, isSectionalReport, reportUrl, testInvitationId);
    }
    updateCandidateJobCardDetails() {
        this.candidateJobCompareActionObject.candidateDetails = {};
        this.candidateProfileActionObject.candidateDetails = {};
        this.sendEmailProfileActionObject.candidateDetails = {};
        this.candidateJobCompareActionObject.candidateDetails = this._setJobMatchCandidateDetails('booklet', this.candidateJobMatch);
        this.candidateProfileActionObject.candidateDetails = this._setJobMatchCandidateDetails('booklet', this.candidateJobMatch);
        this.sendEmailProfileActionObject.candidateDetails = this._setJobMatchCandidateDetails('email', this.candidateJobMatch);
    }
    getCandidateJobMatchCardInfo(successCallback, errorCallback) {
        this.disableProfileLink = false;
        this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
            //resetting available actions as the actions can change when the card state is changed. 
            this.candidateJobMatch.availableActions = [];
            this.candidateJobMatch = angular.merge(this.candidateJobMatch, data);
            // this.candidateJobMatch = angular.copy(this._massageCandidateJobMatchData(this.candidateJobMatch));
            this.candidateJobMatch = this._massageCandidateJobMatchData(this.candidateJobMatch);
            this._setActionsOnTheCard();
            this.loadingFlag = false;
            if (!this.candidateJobMatch.id) {
                this.$rootScope.$emit("REMOVE_JOB_MATCH_CARD", this.candidateJobMatchCopy);
            }
            this.updateCandidateJobCardDetails();
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (errorCallback) {
                errorCallback();
            }
        });
    }
    _setActionsOnTheCard() {
        this._setActionFlags();
        // remove common actions which will show up as icons in the header
        this._removeCommonCardHeaderActions();
        let availableActionsToDisplay = [];
        let updateResumeIndex = this.candidateJobMatch.availableActions.findIndex(item => item.action === 'Upload Resume');
        if (updateResumeIndex !== -1 && (this.is4dot5UserAdmin || this.isSuperUser)) {
            this.candidateJobMatch.availableActions.splice(updateResumeIndex + 1, 0, this.reRunScoreActionObject);
        }
        if (this.candidateJobMatch.availableActions) {
            availableActionsToDisplay = this.candidateJobMatch.availableActions.filter((action) => {
                return action.displayAction == true;
            });
        }
        if ((this.candidateJobMatch.currentStep != 'Not Interested' && this.candidateJobMatch.currentStep != 'Released') && this.candidateJobMatch.email && this.isOutreachEnabled) {
            // Find and remove the 'SEND_OUTREACH' action
            let indexToRemove = _.findIndex(this.candidateJobMatch.availableActions, { actionType: 'SEND_OUTREACH' });
            let element = null;
            if (indexToRemove !== -1) {
                element = this.candidateJobMatch.availableActions.splice(indexToRemove, 1)[0];
            }
            // If not found, create default element
            if (element) {
                // Find index of 'Upload Resume' and insert after it
                let uploadIndex = _.findIndex(this.candidateJobMatch.availableActions, { action: "Upload Resume" });
                if (uploadIndex !== -1) {
                    this.candidateJobMatch.availableActions.splice(uploadIndex + 1, 0, element);
                }
                else {
                    // If "Upload Resume" not found, optionally push to end
                    this.candidateJobMatch.availableActions.push(element);
                }
            }
        }
        else {
            this.candidateJobMatch.availableActions = this.candidateJobMatch.availableActions.filter(action => {
                return !(action.actionType === 'SEND_OUTREACH' && action.allowed === false);
            });
        }
        // add no actions available, if no explicit actions other than the common actions are available for a job match
        if (availableActionsToDisplay.length == 0) {
            this.candidateJobMatch.availableActions = this.candidateJobMatch.availableActions ? this.candidateJobMatch.availableActions : [];
            this.candidateJobMatch.availableActions.push({
                action: "No Actions Available!",
                actionType: "NO_ACTIONS_AVAILABLE",
                allowed: true,
                message: null,
                displayAction: true
            });
        }
        this._setUploadResumeAction();
        this._setDisplayFlags();
        if (this.isFirstStep && (!this.candidateJobMatch.resumeFileName || this.candidateJobMatch.resumeFileName === '') &&
            (!this.candidateJobMatch.resumePdfFileName || this.candidateJobMatch.resumePdfFileName === '')) {
            this.candidateJobMatch.availableActions.forEach(action => {
                if (action.actionType != 'UPLOAD_RESUME' && action.actionType != 'DELETE_JOBMATCH' && action.actionType != 'SEND_OUTREACH') {
                    action.isDisabled = true;
                }
                else {
                    action.isDisabled = false;
                }
            });
        }
        this.candidateJobMatch.availableActions.forEach(action => {
            if (action.actionType === 'SEND_OUTREACH') {
                action.isDisabled = this.candidateJobMatch.isOutreachDisabled;
            }
        });
    }
    _massageCandidateJobMatchData(candidateJobMatch) {
        candidateJobMatch.name = this._setCandidateName(candidateJobMatch);
        candidateJobMatch.jobMatchDate = new Date(candidateJobMatch.jobMatchDate);
        candidateJobMatch.jobLocation = this.jobLocation;
        if (_.isNull(candidateJobMatch.jobMatchRequisitionNum)) {
            candidateJobMatch.jobMatchRequisitionNum = '-';
        }
        if (candidateJobMatch.fromOtherSource) {
            candidateJobMatch.otherSourceNote = "<span>Source: Other<br>Notes: " + candidateJobMatch.otherSourceTypeNotes + "</span>";
        }
        // candidateJobMatch.fromOtherSource = true;
        // candidateJobMatch.otherSourceTypeNotes = "Adding long notes to see how it affects the hover over text and do the needful if required. Also testing special characters <>?:{}|,./;[]\!$%*()_+=-098754321. Should there be a limit to the notes - must think about this and discuss.";
        candidateJobMatch.primaryRecruiter = {};
        candidateJobMatch.primaryRecruiterName = '';
        candidateJobMatch.corpRecruiters = [];
        candidateJobMatch.vendorRecruiters = [];
        let tempPrimaryRecruiterIndex = -1;
        if (!_.isNull(candidateJobMatch.recruitersList) && candidateJobMatch.recruitersList.length) {
            angular.forEach(candidateJobMatch.recruitersList, (val, key) => {
                val.name = val.firstName;
                if (!_.isNull(val.lastName)) {
                    val.name += ' ' + val.lastName;
                }
                if (val.isPrimary && ((this.isCorporateFlag && !val.vendorRecruiter) || (!this.isCorporateFlag))) {
                    candidateJobMatch.primaryRecruiter = val;
                    candidateJobMatch.primaryRecruiterName = val.name;
                    candidateJobMatch.isPrimaryRecruiterVendor = val.vendorRecruiter;
                    tempPrimaryRecruiterIndex = key;
                }
                else if (val.vendorRecruiter) {
                    candidateJobMatch.vendorRecruiters.push(val);
                }
                else {
                    candidateJobMatch.corpRecruiters.push(val);
                }
            });
        }
        if (tempPrimaryRecruiterIndex != -1) {
            // remove the primary recruiter object from the recruiter list array
            candidateJobMatch.recruitersList.splice(tempPrimaryRecruiterIndex, 1);
        }
        if (_.isNull(candidateJobMatch.candidateStatus)) {
            candidateJobMatch.candidateStatus = 'Active';
        }
        if (_.isNull(candidateJobMatch.jobMatchStatus)) {
            candidateJobMatch.jobMatchStatus = 'ACTIVE';
        }
        candidateJobMatch.numberOfOpenOpenings = (candidateJobMatch.totalOpenings - candidateJobMatch.numberOfFilledOpenings);
        //replace Cancelled with Canceled, if it exits
        if (candidateJobMatch.jobMatchCurrentState) {
            candidateJobMatch.jobMatchCurrentStateDisplayLabel = candidateJobMatch.jobMatchCurrentState.replace('Cancelled', 'Canceled');
        }
        // filled or joined in other job details
        candidateJobMatch.filledOrJoinedInOtherJobHeaderText = candidateJobMatch.joinedInOtherJob ? 'Joined' : (candidateJobMatch.filledInOtherJob ? 'Filled' : '');
        candidateJobMatch.filledOrJoinedInOtherJobMatchPopOverTitle = candidateJobMatch.joinedInOtherJob ? 'Joined Requisition Details' : (candidateJobMatch.filledInOtherJob ? 'Filled Requisition Details' : '');
        if (candidateJobMatch.mobilePhoneCountryCodePresent && candidateJobMatch.mobilephone) {
            let phoneNumberObject = libphonenumber.parse(candidateJobMatch.mobilephone.toString());
            if (phoneNumberObject.phone !== undefined) {
                candidateJobMatch.mobilephone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
            }
        }
        this.showAdditionalDetailsIconsFlag = true;
        this.notesDisplay = "";
        if (!_.isNull(candidateJobMatch.reason)) {
            this.notesDisplay = this.notesDisplay + "<b>Reason: </b><p>" + candidateJobMatch.reason + " </p>";
        }
        if (candidateJobMatch.mutipleNotePresent) {
            let multipleNotesExistNote = "<b class='brown'>Multiple Notes available</b>";
            this.notesDisplay = this.notesDisplay + multipleNotesExistNote + "<br>";
        }
        else {
            if (!_.isNull(candidateJobMatch.jobMatchCurrentStateInternalNote) && candidateJobMatch.jobMatchCurrentStateInternalNote.length > 0) {
                if (candidateJobMatch.isSharedRequisition) {
                    this.notesDisplay = this.notesDisplay + "<b>Internal Note: </b> <p>" + this._replaceSpecialCharacters(candidateJobMatch.jobMatchCurrentStateInternalNote) + "</p>";
                }
                else {
                    this.notesDisplay = this.notesDisplay + "<b>Note: </b><p>" + this._replaceSpecialCharacters(candidateJobMatch.jobMatchCurrentStateInternalNote) + "</p>";
                }
            }
            if (!_.isNull(candidateJobMatch.jobMatchCurrentStateExternalNote) && candidateJobMatch.jobMatchCurrentStateExternalNote.length > 0) {
                this.notesDisplay = this.notesDisplay + "<b>External Note: </b><br><p>" + this._replaceSpecialCharacters(candidateJobMatch.jobMatchCurrentStateExternalNote) + "</p>";
            }
        }
        if (this.notesDisplay.length !== 0) {
            this.notesDisplay = "<div class='text-left'>" + this.notesDisplay + "</div>";
        }
        candidateJobMatch.violationType = "";
        if (candidateJobMatch.techAssessmentReportInfoList.length > 0) {
            candidateJobMatch.violationType = candidateJobMatch.techAssessmentReportInfoList[candidateJobMatch.techAssessmentReportInfoList.length - 1].type;
        }
        if (this.isCorporateFlag && this.candidateJobMatch.vendorName !== null) {
            this.showSalary = false;
        }
        candidateJobMatch.workLocationsMatchStatus = this.jobMatchService.getJobAndCandidateWorkLocationsMatchStatus(this.jobWorkLocations, candidateJobMatch.workLocations);
        let outreachState = candidateJobMatch.outreachState ? candidateJobMatch.outreachState : '';
        if (outreachState && outreachState != '') {
            candidateJobMatch.outreachIconStatus = this.sharedService.setOutreachIconStatus(outreachState);
        }
        return candidateJobMatch;
    }
    _setCandidateName(candidate) {
        if (_.isNull(candidate.firstName)) {
            candidate.firstName = "-";
        }
        if (_.isNull(candidate.lastName)) {
            candidate.lastName = "-";
        }
        if (candidate.firstName == "-" && candidate.lastName == "-") {
            candidate.nameWarning = 'First and Last Name Missing';
        }
        else if (candidate.firstName == "-") {
            candidate.nameWarning = "First Name Missing";
        }
        else if (candidate.lastName == "-") {
            candidate.nameWarning = "Last Name Missing";
        }
        else {
            candidate.nameWarning = "";
        }
        return candidate.firstName + ' ' + candidate.lastName;
    }
    _replaceSpecialCharacters(text) {
        let replacedText = text;
        for (let i = 0; i < replacedText.length; i++) {
            replacedText = replacedText.replace('<', '&lt;').replace('>', '&gt;');
        }
        replacedText = replacedText.replace(/&lt;br&gt;/g, '<br>');
        return replacedText;
    }
    _setUploadResumeAction() {
        // if(_.findIndex(this.candidateJobMatch.availableActions, { actionType: 'UPLOAD_RESUME' }) !== -1) {
        //     this.candidateJobMatch.isResumeRequired = true;
        //     this.jobMatchScoreTitle = "Resume is required. Please upload resume asap.";
        // } else {
        //     this.candidateJobMatch.isResumeRequired = false;
        // }
    }
    _setActionFlags() {
        let tempObject = _.find(this.candidateJobMatch.availableActions, { actionType: 'COMMUNICATION' });
        this.showCommunicationFlag = !_.isUndefined(tempObject);
        if (this.showCommunicationFlag) {
            this.communicationActionObject = angular.copy(tempObject);
        }
        tempObject = _.find(this.candidateJobMatch.availableActions, { actionType: 'PEER_COMMUNICATION' });
        this.showPeerCommunicationFlag = !_.isUndefined(tempObject);
        if (this.showPeerCommunicationFlag) {
            this.peerCommunicationActionObject = tempObject;
        }
        tempObject = _.find(this.candidateJobMatch.availableActions, { actionType: 'NOTES' });
        this.showNotesFlag = !_.isUndefined(tempObject);
        if (this.showNotesFlag) {
            this.notesActionObject = tempObject;
        }
        tempObject = _.find(this.candidateJobMatch.availableActions, { actionType: 'ASSIGN_RECRUITER' });
        this.showAssignRecruiterFlag = !_.isUndefined(tempObject);
        if (this.showAssignRecruiterFlag) {
            this.assignRecruiterActionObject = tempObject;
        }
        tempObject = _.find(this.candidateJobMatch.availableActions, { actionType: 'NOT_INTERESTED' });
        this.showNotInterestedFlag = !_.isUndefined(tempObject);
        if (this.showNotInterestedFlag) {
            this.notInterestedActionObject = tempObject;
        }
        tempObject = _.find(this.candidateJobMatch.availableActions, { actionType: 'RELEASE' });
        this.showReleaseFlag = !_.isUndefined(tempObject);
        if (this.showReleaseFlag) {
            this.releaseActionObject = tempObject;
        }
    }
    _removeCommonCardHeaderActions() {
        angular.forEach(this.candidateJobMatch.availableActions, (action, key) => {
            if (action.actionType == "COMMUNICATION"
                || action.actionType == "PEER_COMMUNICATION"
                || action.actionType == "NOTES"
                || action.actionType == "ASSIGN_RECRUITER"
                || action.actionType == "RELEASE"
                || action.actionType == "NOT_INTERESTED") {
                action.displayAction = false;
            }
            else {
                action.displayAction = true;
            }
        });
    }
    _setDisplayFlags() {
        if (!_.isNull(this.candidateJobMatch.jobMatchScore) && this.candidateJobMatch.jobMatchScore.toString() != '') {
            this.showIntelligenceScoreFlag = true;
            if (this.candidateJobMatch.jobMatchScore >= this.candidateJobMatch.fourDotFiveIntelligenceScore) {
                this.intelligenceScorePassFlag = true;
            }
            // round the job 4dot5 intelligence score to the lower integer value.
            this.candidateJobMatch.jobMatchScore = Math.floor(parseFloat(this.candidateJobMatch.jobMatchScore));
        }
        if (!_.isNull(this.candidateJobMatch.techAssessmentScore) && this.candidateJobMatch.techAssessmentScore.toString() != '') {
            this.showTechAssessmentScoreFlag = true;
            if (this.candidateJobMatch.techAssessmentScore >= this.candidateJobMatch.techAssessmentThresholdScore) {
                this.techAssessmentScorePassFlag = true;
            }
            // round the tech assessment score to the lower integer value.
            this.candidateJobMatch.techAssessmentScore = Math.floor(parseFloat(this.candidateJobMatch.techAssessmentScore));
        }
        if (!_.isNull(this.candidateJobMatch.valueAssessmentScore) && this.candidateJobMatch.valueAssessmentScore.toString() != '') {
            this.showValueAssessmentScoreFlag = true;
        }
        if (((this.candidateJobMatch.jobMatchCurrentState == 'Phone Screen Scheduled' || this.candidateJobMatch.jobMatchCurrentState == 'Phone Screen In Progress' || this.candidateJobMatch.jobMatchCurrentState == 'Phone Screen Completed' || this.candidateJobMatch.jobMatchCurrentState == 'Phone Screen Overdue' || this.candidateJobMatch.jobMatchCurrentState == 'Joined' || this.candidateJobMatch.jobMatchCurrentState == 'Filled') && this.candidateJobMatch.numberOfOpenPhoneScreens > 0) || this.candidateJobMatch.jobMatchCurrentState == 'Phone Screen Canceled') {
            this.showPhoneScreenCountFlag = true;
        }
        if (((this.candidateJobMatch.jobMatchCurrentState == 'Interview Scheduled' || this.candidateJobMatch.jobMatchCurrentState == 'Interview In Progress' || this.candidateJobMatch.jobMatchCurrentState == 'Interview Completed' || this.candidateJobMatch.jobMatchCurrentState == 'Interview Overdue' || this.candidateJobMatch.jobMatchCurrentState == 'Joined' || this.candidateJobMatch.jobMatchCurrentState == 'Filled') && this.candidateJobMatch.numberOfOpenInterviews > 0) || this.candidateJobMatch.jobMatchCurrentState == 'Interview Canceled') {
            this.showInterviewCountFlag = true;
            this.showPhoneScreenCountFlag = false;
        }
        // if it is an assessment related state and not one of 'In Tech Assessment' and 'In Value Assessment', then show assessment info
        if ((this.candidateJobMatch.jobMatchCurrentState && this.candidateJobMatch.jobMatchCurrentState.indexOf('Assessment') != -1) && (this.candidateJobMatch.jobMatchCurrentState != 'In Tech Assessment') && (this.candidateJobMatch.jobMatchCurrentState != 'In Value Assessment')) {
            this.showAssessmentInfoFlag = true;
        }
        if (!_.isNull(this.candidateJobMatch.techAssessmentAdditionalInfoDto)) {
            angular.forEach(this.candidateJobMatch.techAssessmentAdditionalInfoDto.commentList, (comment, key) => {
                comment.showShortMessageFlag = true;
                comment.lastModifiedDate = new Date(comment.lastModifiedDate);
            });
        }
    }
    checkWorkflowFirstStepFirstState(currentState, actionType) {
        let firstActionOfFirstStepOfWorkflow = ['START_SCREENING', 'SEND_TECHNICAL_ASSESSMENT', 'SEND_VALUE_ASSESSMENT', 'SCHEDULE_PHONE_SCREEN', 'SCHEDULE_INTERVIEW'];
        let firstStateOfWorkflowSteps = ['In Soft Qualified', 'In Tech Assessment', 'In Value Assessment', 'In Phone Screen', 'In Interview'];
        return firstStateOfWorkflowSteps.includes(currentState) && firstActionOfFirstStepOfWorkflow.includes(actionType);
    }
    performAction(actionObject) {
        if (actionObject.action === 'Send Candidate Outreach') {
            let candidateType = this.candidateJobMatch.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
            this.candidateJobMatch.outreachActiveJob = true;
            this.candidateJobMatch.requisitionNumber = this.candidateJobMatch.jobMatchRequisitionNum;
            this.candidateJobMatch.jobTitle = this.candidateJobMatch.jobMatchTitle;
            this.candidateJobMatch.companyName = this.candidateJobMatch.clientOrBUName ? this.candidateJobMatch.clientOrBUName : this.candidateJobMatch.jobMatchClientName ? this.candidateJobMatch.jobMatchClientName : '';
            this.candidateJobMatch.jobLocationText = this.jobMatchService.setJobLocationText(this.candidateJobMatch.jobLocation);
            this.candidateJobMatch.jobId = this.candidateJobMatch.jobMatchJobId;
            this.jobMatchActionsService.openSendOutreachEmailModal([this.candidateJobMatch], this.isVendorOnly, this.companyId, this.userId, this.candidateJobMatch.id, this.candidateJobMatch.clientOrBUId, candidateType, this.salaryDurationOptions, this.jobTypeList, this.candidateJobMatch.name, (data) => { });
        }
        else if (actionObject.actionType == "RUN_CANDIDATE_SCORE") {
            this.alertsAndNotificationsService.showConfirm(actionObject.action, "Are you sure you want to run the candidate score?", "warning", true, () => {
                let requestObject = new RunCandidateScore(this.companyId, this.userId);
                requestObject.candidateId = this.candidateJobMatch.id;
                requestObject.jobMatchId = this.candidateJobMatch.jobMatchId;
                requestObject.rerunType = "CANDIDATE_JOB";
                requestObject.candidateType = this.candidateJobMatch.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
                this.resumeService.reRunResumeScore(requestObject, (data) => {
                    this.alertsAndNotificationsService.showAlertWithCallBack("Candidate scoring in Progress", data.message, "success", () => { });
                }, (error) => {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }, () => {
                //do nothing
            });
        }
        else if (this.isFirstStep && this.checkWorkflowFirstStepFirstState(this.candidateJobMatch.jobMatchCurrentState, actionObject.actionType)) {
            let releasedCandidateDetail = this.candidateJobMatch.releasedCandidateDetail;
            let isCandidateAvailable = releasedCandidateDetail ? new Date() >= new Date(releasedCandidateDetail.releasedUpTo) : true;
            if (!isCandidateAvailable) {
                let suspendedMonths = 0;
                let releaseDate = '';
                let candidateId = this.candidateJobMatch.id;
                let candidateName = this.candidateJobMatch.firstName + " " + this.candidateJobMatch.lastName;
                let clientOrBuName = releasedCandidateDetail.releasedBy;
                suspendedMonths = releasedCandidateDetail.numberOfMonthsToWait;
                releaseDate = this.$filter('fourdotfiveDateFormat')(releasedCandidateDetail.releasedAt);
                let displayHtmlText = "";
                displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' was released within the '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of another job match for the same '<span class='emerald'>" + clientOrBuName + "</span>' with a release date of '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>'";
                displayHtmlText = displayHtmlText + "<br></p><p>Do you still want to continue?</p>";
                this.alertsAndNotificationsService.showConfirm('Candidate Released', displayHtmlText, "warning", true, () => {
                    this.performJobMatchCardAction(actionObject);
                }, () => {
                    //do nothing
                });
            }
            else {
                this.performJobMatchCardAction(actionObject);
            }
        }
        else {
            if (actionObject.actionType == "NOTES" || actionObject.actionType == "COMMUNICATION" || actionObject.actionType == "PEER_COMMUNICATION") {
                actionObject.candidateDetails = this._setJobMatchCandidateDetails('email', this.candidateJobMatch);
            }
            this.performJobMatchCardAction(actionObject);
        }
    }
    performJobMatchCardAction(actionObject) {
        actionObject.formalizeActivityPayload = {
            candidate: new FormalizeCandidate(this.candidateJobMatch.id, this.candidateJobMatch.firstName, this.candidateJobMatch.lastName),
            requisition: new FormalizeRequisition(this.candidateJobMatch.jobMatchJobId, this.candidateJobMatch.jobMatchRequisitionNum, this.candidateJobMatch.jobMatchTitle),
            jobMatch: new FormalizeJobMatch(this.candidateJobMatch.jobMatchId, this.candidateJobMatch.jobMatchJobId, this.candidateJobMatch.jobMatchRequisitionNum, this.candidateJobMatch.jobMatchTitle),
            company: new FormalizeCompany(this.companyId, this.candidateJobMatch.currentJobCompanyName, this.candidateJobMatch.clientOrBUId, this.candidateJobMatch.clientOrBUName)
        };
        this.jobMatchActionsService.performAction('candidateJobMatchCard', actionObject, this.candidateJobMatch, () => {
            this.saveCallback();
        }, () => {
            if (actionObject.actionType != "UPDATE_CONTACT") {
                this.refreshCard();
            }
        });
    }
    openMeetingsModal() {
        let meetingType = '';
        if (this.showInterviewCountFlag) {
            meetingType = 'Interview';
        }
        else if (this.showPhoneScreenCountFlag) {
            meetingType = 'PhoneScreen';
        }
        this.jobMatchActionsService.openMeetingsModal(this.jobMatchId, meetingType, () => {
            this.refreshCard();
        });
    }
    openAssessmentInfoModal() {
        let assessmentType = 'Tech Assessment';
        if (this.candidateJobMatch.jobMatchCurrentState.indexOf('Value Assessment') != -1) {
            assessmentType = 'Value Assessment';
        }
        this.jobMatchActionsService.openAssessmentInfoModal(this.jobMatchId, assessmentType);
    }
    openImageProctoringInfoModal() {
        this.jobMatchActionsService.openImageProctoringInfoModal(this.candidateJobMatch.techAssessmentReportInfoList[this.candidateJobMatch.techAssessmentReportInfoList.length - 1], this.candidateJobMatch.techAssessmentReportInfoList);
    }
    cardMenuToggled(openFlag, id) {
        if (openFlag) {
            this.$timeout(() => {
                scrollIntoView(document.getElementById(id), { behavior: "smooth", block: "end", scrollMode: "if-needed" });
            }, 200);
        }
    }
    showAllActivityModal() {
        this.jobMatchActionsService.showAllActivityModal(this.candidateJobMatch, this.jobMatchId, this.activityMap);
    }
    expandText($event, comment) {
        if (comment.showShortMessageFlag) {
            comment.showShortMessageFlag = false;
        }
        else {
            comment.showShortMessageFlag = true;
        }
        $event.stopPropagation();
    }
    toggleCardSelection() {
        this.candidateJobMatch.selectedFlag = !this.candidateJobMatch.selectedFlag;
    }
    showRecentActivities() {
        this.recentActivitiesControls.activityClickCount++;
        this.isActivityClicked = !this.isActivityClicked;
    }
    showNotifications() {
        this.userNotificationControls.notificationClickCount++;
        this.isNotificationClicked = !this.isNotificationClicked;
    }
    confirmOpeningPhoneConference() {
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: "Do you want to call the candidate?",
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'No',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this._openPhoneConference();
                }
            }
        });
    }
    _openPhoneConference() {
        let conferenceDetails = { jobMatchId: this.jobMatchId, jobId: this.candidateJobMatch.jobMatchJobId, candidateId: this.candidateJobMatch.id };
        let step = "";
        if (this.candidateJobMatch.currentStep === "Recruiter Screening") {
            step = "rs";
        }
        else if (this.candidateJobMatch.currentStep === "Tech Assessment") {
            step = "ta";
        }
        else if (this.candidateJobMatch.currentStep === "Value Assessment") {
            step = "va";
        }
        else if (this.candidateJobMatch.currentStep === "Phone Screen") {
            step = "ps";
        }
        else if (this.candidateJobMatch.currentStep === "Interview") {
            step = "in";
        }
        else if (this.candidateJobMatch.currentStep === "Not Interested") {
            step = "ni";
        }
        else if (this.candidateJobMatch.currentStep === "Released") {
            step = "r";
        }
        let absUrl = this.StorageService.get('baseurl') + '/#/conference?jm=' + this.jobMatchId + '&ws=' + step + '&mode=PHONE';
        window.open(absUrl, '_blank');
    }
    _setCandidateEmailSubjectAndBody(candidate) {
        let candidateInformation = {};
        candidateInformation.subject = `Candidate Information: ${candidate.firstName ? candidate.firstName : ""} ${candidate.lastName ? candidate.lastName : ""} – ${candidate.jobMatchTitle} (Req #${candidate.jobMatchRequisitionNum})`;
        candidateInformation.body = '';
        candidate.candidateAdditionalDetails.preferredWorkLocations = this.candidateJobMatch.workLocations;
        candidateInformation.candidateInfoInEmailBody = this.jobMatchActionsService._setCandidateInfoInEmailBody(candidate, candidate.candidateAdditionalDetails);
        return candidateInformation;
    }
    _setCandidateVendorDetails(candidate) {
        let vendorId = null;
        if (candidate.vendorName && this.assignedVendorDetails) {
            this.assignedVendorDetails.map(vendor => {
                if (vendor.vendorName == candidate.vendorName) {
                    vendorId = vendor.vendorId;
                }
            });
        }
        return vendorId;
    }
    _setJobMatchCandidateDetails(type, candidateJobMatch) {
        let candidateDetails = {};
        candidateDetails.context = 'candidateJobMatchCard';
        candidateDetails.resumeFileName = candidateJobMatch.resumePdfFileName;
        candidateDetails.resumeXRXml = candidateJobMatch.resumePdfFileName ? candidateJobMatch.resumePdfFileName.replace(/\.\w+/, '.xml') : '';
        candidateDetails.showOnlyJobMatchUsers = true;
        candidateDetails.candidateType = candidateJobMatch.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
        candidateDetails.jobMatchId = this.jobMatchId;
        candidateDetails.candidateEmailSubjectAndBodyInformation = this._setCandidateEmailSubjectAndBody(candidateJobMatch);
        candidateDetails.isSharedRequisition = candidateJobMatch.isSharedRequisition;
        candidateDetails.vendorId = this._setCandidateVendorDetails(candidateJobMatch);
        candidateDetails.corporateName = candidateJobMatch.corporateCompanyName;
        candidateDetails.jobMatchRequisitionId = candidateJobMatch.jobMatchJobId;
        candidateDetails.clientOrBuId = candidateJobMatch.clientOrBUId;
        candidateDetails.currentStep = candidateJobMatch.currentStep;
        if (type == 'email') {
            candidateDetails.candidateEmail = candidateJobMatch.email;
            candidateDetails.name = candidateJobMatch.firstName + candidateJobMatch.lastName;
            candidateDetails.candidateId = candidateJobMatch.id;
            candidateDetails.companyId = this.$rootScope.userDetails.company.companyId;
            candidateDetails.showOnlyJobMatchUsers = true;
            candidateDetails.requisitionRecruitersList = this.allRecruitersAndHiringManagers;
        }
        return candidateDetails;
    }
    getCandidateJobMatches(successCallback) {
        let jobMatchesObject = new JobMatchQueryFilter();
        jobMatchesObject.candidateId = this.candidateJobMatch.id;
        jobMatchesObject.userId = this.userId;
        jobMatchesObject.companyId = this.companyId;
        jobMatchesObject.top5Flag = false;
        jobMatchesObject.candidateType = this.candidateJobMatch.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
        jobMatchesObject.searchText = '';
        jobMatchesObject.vendorIds = [];
        this.jobMatchService.getDetailedCandidateJobMatches(jobMatchesObject, this.companyId, 1, 250, (data) => {
            data.forEach((jobMatch) => {
                jobMatch.requisitionNumber = jobMatch.candidateJobMatchCardDetails.jobMatchRequisitionNum;
                jobMatch.jobLocationText = this.jobMatchService.setJobLocationText(jobMatch.jobLocation);
                jobMatch.candidateJobMatchCardDetails.availableActions.forEach((action) => {
                    if (action.actionType === 'SEND_OUTREACH') {
                        jobMatch.isOureachActionAvailable = true;
                    }
                    else {
                        jobMatch.isOureachActionAvailable = false;
                    }
                });
                jobMatch.jobMatchSelected = false;
            });
            if (successCallback) {
                successCallback(data);
            }
        }, (error) => {
            this.loadingFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    ;
    $onDestroy() {
        this.workFlowUpdateListener();
    }
}
CandidateJobMatchCardController.$inject = ['$rootScope', '$state', '$timeout', '$filter', 'StorageService', 'jobMatchService', 'jobMatchActionsService', 'webSocketsService', 'alertsAndNotificationsService', 'resumeService', 'userRoleService', 'candidateService', 'companyService', 'sharedService'];
// import * as TEMPLATE from './candidate-job-match-card.html';
import * as TEMPLATE from 'raw-loader!./candidate-job-match-card.html';
export const CandidateJobMatchCardComponent = {
    selector: 'candidateJobMatchCard',
    component: {
        bindings: {
            'candidateId': '@',
            'jobMatchId': '@',
            'jobLocation': '@',
            'requisitionSponsorships': '<',
            'jobWorkLocations': '<',
            'context': '@',
            'saveCallback': '&',
            'candidateJobMatch': '=',
            'salaryDurationOptions': '<',
            'disabledFlag': '<',
            'activityMap': '<',
            'jobTypeList': '<',
            'allRecruitersAndHiringManagers': '<',
            'assignedVendorDetails': '<',
            'isFirstStep': '<',
            'workflowFirstStep': '@',
            'isOutreachEnabled': '<',
            'resumeRequiredForWorkflow': '<'
        },
        controller: CandidateJobMatchCardController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card.html'
    }
};
//# sourceMappingURL=candidate-job-match-card.component.js.map